<template>
  <div class="application-list-detail" v-loading="loading">
    <el-divider></el-divider>
    <div class="content">
      <div class="first-line">
        <div class="line-left">
          <img :src="detailData.square_logo_url" alt="#" />
        </div>
        <div class="line-right">
          <p class="title">{{ detailData.name }}</p>
          <p class="subscribe">{{ detailData.description }}</p>
        </div>
      </div>
      <div class="second-line">
        <el-form
          ref="detail-form"
          class="detail-form"
          :model="detailData"
          label-position="left"
          label-width="100px"
          :rules="rules"
        >
          <el-form-item label="AgentId" prop="agent_id">
            <el-input
              v-model.trim="detailData.agent_id"
              placeholder="请与企业微信应用Agentld保持一致"
              style="width: 500px"
              clearable
            ></el-input>
            <p class="tip" @click="getTip">如何获取</p>
          </el-form-item>
          <el-form-item label="Secret" prop="app_secret">
            <el-input
              v-model.trim="detailData.app_secret"
              placeholder="请与企业微信应用Secret保持一致"
              style="width: 500px"
              clearable
            ></el-input>
            <p class="tip" @click="getTip">如何获取</p>
          </el-form-item>
          <el-form-item label="控制台网址" prop="console_url">
            <el-input
              v-model.trim="detailData.console_url"
              placeholder="请输入控制台网址"
              style="width: 500px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="可见范围">
            <span v-for="item in detailData.allow_userinfos" :key="item.userid">
              {{ item.name }}
            </span>
            <span v-for="item in detailData.allow_partys" :key="item.partyid">
              {{ item.party_name }}
            </span>
          </el-form-item>
          <!-- <el-form-item label="管理员">
            <el-tag
              type="info"
              v-for="(item, index) in detailData.allow_tags"
              :key="item.tagid"
              ><i class="el-icon-user-solid"></i>{{ item.tag_name }}</el-tag
            >
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="footer">
      <el-button
        class="btn-width"
        @click="
          () => {
            closeComp('back');
          }
        "
      >
        取消
      </el-button>
      <el-button type="primary" class="btn-width" @click="save">保存</el-button>
    </div>
    <!-- 如何获取de弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :popper-append-to-body="true"
      class="detail-dialog"
      width="920px"
    >
      <div slot="title" class="dialog-header">
        <div class="title">如何获取</div>
      </div>
      <div class="dialog-body">
        <img :src="g_imgSrc.applicationManagement" alt="#" style="width: 790px" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { EyaoSaasGetAppInfoDetail, EyaoSaasSaveAppInfo } from '@/api/enterpriseWeChatManagement';
export default {
  name: 'ApplicationDetail',
  components: {},
  data() {
    return {
      agent_id: {}, // 表格当前行传过来的数据
      loading: false,
      dialogVisible: false,
      detailData: {}, // 详情数据
      rules: {
        agent_id: [{ required: true, message: '必填项', trigger: 'change' }],
        app_secret: [{ required: true, message: '必填项', trigger: 'change' }],
        console_url: [{ required: false }],
      },
    };
  },
  computed: {},
  created() {
    this.agent_id = this.$route.query.agent_id;
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      try {
        const result = await EyaoSaasGetAppInfoDetail({
          agent_id: this.agent_id,
        });
        if (result) {
          this.detailData = result;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.loading = false;
    },
    // 保存
    save() {
      this.loading = true;
      this.$refs['detail-form'].validate(async (valid) => {
        if (valid) {
          try {
            const result = await EyaoSaasSaveAppInfo({
              id: this.detailData.id,
              agent_id: this.detailData.agent_id,
              app_secret: this.detailData.app_secret,
              console_url: this.detailData.console_url,
            });
            if (result) {
              this.closeComp('save');
              this.$message.success('保存成功');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
        } else {
          return false;
        }
      });
      this.loading = false;
    },
    // 隐藏组件  val = 'back'(返回)  'save'(保存或发布)
    closeComp() {
      this.g_tourl(`/saas/applicationManagement.html`);
    },
    // 如何获取
    getTip() {
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.application-list-detail {
  .header {
    height: 84px;
    line-height: 84px;
    font-size: 18px;
    color: #313233;
    cursor: pointer;
    span {
      float: left;
      margin-right: 16px;
    }
    .gray {
      font-size: 16px;
      color: #606266;
    }
  }
  .content {
    .first-line {
      display: flex;
      margin-bottom: 50px;
      .line-left {
        img {
          width: 80px;
          height: 80px;
          object-fit: cover;
          border-radius: 4px;
        }
      }
      .line-right {
        padding-left: 15px;
        .title {
          font-size: 24px;
          color: #303133;
          line-height: 34px;
        }
        .subscribe {
          font-size: 16px;
          color: #909399;
          line-height: 46px;
        }
      }
    }
    .second-line {
      margin-bottom: 50px;
      // 如何获取
      .tip {
        display: inline-block;
        padding-left: 10px;
        color: #2f96ff;
        cursor: pointer;
        &:hover {
          color: #6eb6fd;
        }
      }
    }
  }
  .footer {
    text-align: center;
    .btn-width {
      margin-right: 10px;
      width: 148px;
      height: 48px;
    }
  }

  .detail-dialog {
    // 自定义布局
    .dialog-header {
      display: flex;
      justify-content: space-between;
      padding: 30px 22px 10px 22px;
      .title {
        font-size: 16px;
        color: #303133;
      }
      .icon-guanbi {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
    .dialog-body {
      text-align: center;
      img {
        padding: 25px;
        background: rgba(245, 247, 250, 0.45);
        border-radius: 8px;
        border-radius: 8px;
      }
    }
  }
}
</style>
